'use client';

import type { ExecutiveTeamHeaderType } from './data';

import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const ExecutiveTeamHeader: ExecutiveTeamHeaderType = () => {
  const { t } = useTranslation('pages');

  return (
    <>
      <Container>
        <Breadcrumb
          list={[
            { title: routes.home.title, href: routes.home.url },
            {
              title: routes.executiveTeam.title,
              href: routes.executiveTeam.url,
            },
          ]}
        />
      </Container>
      <PublicPageHeading title={t('executiveTeam.liaExecutiveTeam')} />
    </>
  );
};
export default ExecutiveTeamHeader;
